import { render, staticRenderFns } from "./OrderableCartItemSectionNote.vue?vue&type=template&id=35cb22aa&"
import script from "./OrderableCartItemSectionNote.vue?vue&type=script&lang=ts&"
export * from "./OrderableCartItemSectionNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports